import React from 'react';
import {
  colors,
  fontSizes,
  fontWeights,
  fonts,
  lineHeights,
} from '../../../config/theme/tokens';
import { Typography } from '@mui/material';

type TextProps = {
  id?: string;
  fontSize?: keyof typeof fontSizes;
  fontWeight?: keyof typeof fontWeights;
  color?: keyof typeof colors;
  lineHeight?: keyof typeof lineHeights;
  className?: string;
  translate?: 'yes' | 'no';
  children: React.ReactNode;
};

export const Text: React.FC<TextProps> = ({
  id,
  fontSize = 'md',
  fontWeight = 'regular',
  color = 'neutral70',
  className,
  translate,
  lineHeight,
  children,
}) => {
  if (lineHeight) {
    return (
      <Typography
        id={id}
        className={className}
        translate={translate}
        fontFamily={fonts.secondary}
        fontSize={fontSizes[fontSize]}
        fontWeight={fontWeights[fontWeight]}
        color={colors[color]}
        lineHeight='120%'
      >
        {children}
      </Typography>
    );
  }

  return (
    <Typography
      id={id}
      className={className}
      fontFamily={fonts.secondary}
      fontSize={fontSizes[fontSize]}
      fontWeight={fontWeights[fontWeight]}
      color={colors[color]}
      lineHeight='120%'
    >
      {children}
    </Typography>
  );
};
